import { useEffect } from "react";
import { Outlet, useLoaderData, useSubmit } from "react-router-dom";
import { getTokenDuration } from "../../util/admin/authAdmin";
import styles from "./RootLayoutDashboardAdmin.module.css";
import SideBarAdmin from "./SideBarAdmin";

function RootLayoutDashboardAdmin() {
   const token = useLoaderData();
   const submit = useSubmit();

   useEffect(() => {
      if (!token) {
         return;
      }

      if (token === "EXPIRED") {
         submit(null, { action: "/logout", method: "post" });
         return;
      }

      const tokenDuration = getTokenDuration();

      setTimeout(() => {
         submit(null, { action: "/logout", method: "post" });
      }, tokenDuration);
   }, [token, submit]);
   return (
      <div className={styles.wrapper}>
         <SideBarAdmin></SideBarAdmin>
         <main>
            {/* {navigation.state === 'loading' && <p>Loading...</p>} */}
            <Outlet />
         </main>
      </div>
   );
}

export default RootLayoutDashboardAdmin;
